var _path, _path2, _linearGradient, _filter, _path3, _filter2, _path4, _filter3, _path5, _linearGradient2, _filter4, _path6, _path7, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthereumLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1396,
    height: 1973,
    viewBox: "0 0 1396 1973",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line",
    fill: "none",
    stroke: "#14044d",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 693.00061 1409 L 692.999695 1305"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path-copy-2",
    fill: "#14044d",
    fillOpacity: 0.795578,
    fillRule: "evenodd",
    stroke: "#14044d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 693 849 L 1233 1090 L 693 1409 Z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1",
    x1: 154,
    y1: 1129,
    x2: 693,
    y2: 1129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#716b94",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37367b",
    stopOpacity: 1
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter1",
    x: 0,
    y: 0,
    width: 1396,
    height: 1973,
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11.307537,
    dy: 9.855942,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "offsetblur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path-copy-3",
    fill: "url(#linearGradient1)",
    fillOpacity: 0.795578,
    fillRule: "evenodd",
    stroke: "#14044d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#filter1)",
    d: "M 693 849 L 693 1409 L 154 1091 Z"
  })), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "filter2",
    x: 0,
    y: 0,
    width: 1396,
    height: 1973,
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 13.314791,
    dy: 4.326238,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "offsetblur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#37367b",
    fillOpacity: 0.796849,
    stroke: "#14044d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#filter2)",
    d: "M 693 1409 L 693 1850 L 1232 1090 Z"
  })), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "filter3",
    x: 0,
    y: 0,
    width: 1396,
    height: 1973,
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 70
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 11.412678,
    dy: 3.708204,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "offsetblur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#716b94",
    fillOpacity: 0.801464,
    stroke: "#14044d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#filter3)",
    d: "M 154 1091 L 693 1850 L 693 1409 Z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient2",
    x1: 154,
    y1: 1129,
    x2: 1232,
    y2: 1129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#716b94",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37367b",
    stopOpacity: 1
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "filter4",
    x: 0,
    y: 0,
    width: 1396,
    height: 1973,
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: 0,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "offsetblur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path-copy",
    fill: "url(#linearGradient2)",
    fillOpacity: 0.816398,
    fillRule: "evenodd",
    stroke: "#14044d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#filter4)",
    d: "M 693 849 L 1232 1090 L 693 1409 L 154 1091 L 693 849 Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    fill: "#37367b",
    fillOpacity: 0.91861,
    fillRule: "evenodd",
    stroke: "#14044d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M 693 745 L 1232 987 L 693 1304 L 154 987 L 693 745 Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "filter5",
    x: 0,
    y: 0,
    width: 1396,
    height: 1973,
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 14,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "offsetblur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    fill: "#37367b",
    fillOpacity: 0.798535,
    stroke: "#14044d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#filter5)",
    d: "M 1232 987 L 693 92 L 693 1305 Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter6",
    x: 0,
    y: 0,
    width: 1396,
    height: 1973,
    filterUnits: "userSpaceOnUse",
    primitiveUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.187697,
    dy: 13.632263,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "offsetblur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    fill: "#716b94",
    fillOpacity: 0.801255,
    stroke: "#14044d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    filter: "url(#filter6)",
    d: "M 693 92 L 154 987 L 693 1305 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumLogo);
export default __webpack_public_path__ + "static/media/EthereumLogo.e51cd5a407e6e0ee2b1f59e43db63274.svg";
export { ForwardRef as ReactComponent };